export const MixedFieldContent = 'Contains different values';